exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".layer[data-v-04cadf4d]{background-color:rgba(0,0,0,.75);position:fixed;top:0;right:0;bottom:0;left:0;margin:0;padding:0;z-index:3000}.tip[data-v-04cadf4d]{position:absolute;left:calc(50% - 69px);top:calc(50% - 25px);text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04cadf4d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/libs/Loading.vue
// module id = 395
// module chunks = 1